<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'system-sysCustomerExport',
  components: {
    PageTable,
  },
}
</script>
